import classNames from 'classnames'

const PanelBody = ({ children, collapsible, isOpen }) => (
  <div class={classNames({
    'panel-body': true,
    'panel-body--collapsible': collapsible,
    'panel-body--collapse': !isOpen }
  )}>
    {children}
  </div>
)

export default PanelBody
